import Route from 'mewe/routes/route';

export default class All extends Route {
  theme = 'group';

  beforeModel() {
    const groupId = this.paramsFor('app.group').group_id;
    this.dispatch('group', 'fetchCounters', groupId);
  }

  model() {
    return this.modelFor('app.group');
  }
}
